<mat-checkbox [class]="class" [formControl]="formControl" color="primary">
  @if (!!icon) {
    <ng-icon [name]="icon" class="text-lg"></ng-icon>
  }
{{ label }}</mat-checkbox>